module.exports = __webpack_public_path__ + "media/assets/icons/chevron-right-white-c83a5e27b9b7f111b0b4db3e5fc855b6.svg";